import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import notificationCloseIcon from "../../assets/SVGs/notification-closs-icon.svg";
import { DashboardNotificationSection } from "./DashboardNotificationSection";
import { SavedDashboard2 } from "./SavedDashboard2";
import { SavedDashboard3 } from "./SavedDashboard3";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Modal, Icon, Spin } from "antd";
import DEATH_API from "../../apis/death.api";
import SelectDashboardComponentsModal from "./SelectDashboardComponentsModal";
import { SavedDashboard1 } from "./SavedDashboard1";
import { useTheme } from "../../utils/ThemeContext";
import swal from "sweetalert";
import { DashboardNamesSkeleton } from "../Skeletons/DashboardNamesSkeleton";
import { CustomSkeleton } from "./CustomSkeleton";
import ModalVideo from "../ModuleVideos/ModalVideo";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";
import { NewUserOnboardingWidget } from "./NewUserOnboardingWidget";
import "./switch-dashboard-main.css";

export const SwtichDashboardMain = () => {
  const { theme, toggleTheme } = useTheme();
  const history = useHistory();

  const [callState, setCallState] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTitlesForDashboard2, setSelectedTitlesForDashboard2] =
    useState([]);
  const [selectedTitlesForDashboard1, setSelectedTitlesForDashboard1] =
    useState([]);
  const [saveTilesLoading, setSaveTilesLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [originalSetting, setOriginalSetting] = useState([]);
  const [selectedTitlesForDashboard3, setSelectedTitlesForDashboard3] =
    useState([]);
  const [openNotificationContainer, setOpenNotificationContainer] =
    useState(false);
  const [compareFilter, setCompareFilter] = useState("Dashboard 1");
  const [unselectTitles1, setUnselectTitles1] = useState([]);
  const [unselectTitles2, setUnselectTitles2] = useState([]);
  const [unselectTitles3, setUnselectTitles3] = useState([]);
  const [editDashboard, setEditDashboard] = useState(false);
  const [dashboardFormData, setDashboardFormData] = useState(null);
  const [dashboardFilter, setDashboardFilter] = useState([]);
  const [unsavedDraggableState, setUnsavedDraggableState] = useState(false);
  const [dragButtonVisible, setDragButtonVisible] = useState(false);
  const [showOnboardingWidget, setShowOnboardingWidget] = useState(() => {
    const settingRaw = localStorage.getItem("setting");
    if (settingRaw && settingRaw !== "undefined") {
      try {
        const settings = JSON.parse(settingRaw);
        if (settings.showOnboardingWidget !== undefined) {
          return settings.showOnboardingWidget;
        }
      } catch (e) {
        console.error("Error parsing settings for onboarding state", e);
      }
    }
    return false;
  });


  const handleOnboardingToggle = async (show) => {
    setShowOnboardingWidget(show);

    const settingRaw = localStorage.getItem("setting");
    let userSettings =
      settingRaw && settingRaw !== "undefined" ? JSON.parse(settingRaw) : {};

    userSettings.showOnboardingWidget = show;

    // Optimistic update
    localStorage.setItem("setting", JSON.stringify(userSettings));
    setOriginalSetting({ ...userSettings });

    try {
      await DEATH_API.updateUserAssetSetting(userSettings);
    } catch (error) {
      console.error("Error updating onboarding visibility:", error);
    }
  };


  const handleOnboardingClose = () => {
    handleOnboardingToggle(false);
  };

  const handleOnboardingOpen = () => {
    handleOnboardingToggle(true);
  };

  const themesData = [
    { id: 1, filter: "Dark" },
    { id: 2, filter: "Light" },
  ];
  const currentDashboard =
    dashboardFilter &&
    dashboardFilter.find((dashboard) => dashboard.filter === compareFilter);
  const showInitialDashboardSkeleton =
    loading || !dashboardFilter || dashboardFilter.length === 0 || !currentDashboard;
  const userSettings =
    localStorage.getItem("setting") != "undefined" &&
    JSON.parse(localStorage.getItem("setting"));
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const updateUserDragCards = async () => {
    try {
      setSaveTilesLoading(true);
      let payload = {
        ...userSettings,
        updatedDate: new Date(),
      };
      if (
        currentDashboard &&
        currentDashboard.component === "SavedDashboard1"
      ) {
        setCallState(false);
        payload.dashboard1DragCards = [
          ...userSettings.dashboard1DragCards.filter(
            (item) => !unselectTitles1.includes(item.id)
          ),
          ...selectedTitlesForDashboard1,
        ];

        const uniqueDashboard1DragCards = [];
        const idSet = new Set();

        payload.dashboard1DragCards.forEach((item) => {
          if (!idSet.has(item.id)) {
            idSet.add(item.id);
            uniqueDashboard1DragCards.push(item);
          }
        });

        payload.dashboard1DragCards = uniqueDashboard1DragCards;
      }

      if (
        currentDashboard &&
        currentDashboard.component === "SavedDashboard2"
      ) {
        setCallState(false);
        payload.dashboard2DragCards = [
          ...userSettings.dashboard2DragCards.filter(
            (item) => !unselectTitles2.includes(item.id)
          ),
          ...selectedTitlesForDashboard2,
        ];

        const uniqueDashboard2DragCards = [];
        const idSet = new Set();

        payload.dashboard2DragCards.forEach((item) => {
          if (!idSet.has(item.id)) {
            idSet.add(item.id);
            uniqueDashboard2DragCards.push(item);
          }
        });

        payload.dashboard2DragCards = uniqueDashboard2DragCards;
      }

      if (
        currentDashboard &&
        currentDashboard.component === "SavedDashboard3"
      ) {
        setCallState(false);
        payload.dashboard3DragCards = [
          ...userSettings.dashboard3DragCards.filter(
            (item) => !unselectTitles3.includes(item.id)
          ),
          ...selectedTitlesForDashboard3,
        ];

        const uniqueDashboard3DragCards = [];
        const idSet = new Set();

        payload.dashboard3DragCards.forEach((item) => {
          if (!idSet.has(item.id)) {
            idSet.add(item.id);
            uniqueDashboard3DragCards.push(item);
          }
        });

        payload.dashboard3DragCards = uniqueDashboard3DragCards;
      }

      const response = await DEATH_API.updateUserAssetSetting(payload);
      if (response.status === 200) {
        setCallState(true);
        await getUserRole();
      }
      setSaveTilesLoading(false);
    } catch (error) {
      setSaveTilesLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      localStorage.getItem("setting") != "undefined" &&
      JSON.parse(localStorage.getItem("setting"))
    ) {
      updateUserSetting();
    } else {
      getUserRole();
    }
  }, []);

  useEffect(() => {
    if (!currentDashboard && dashboardFilter && dashboardFilter.length > 0) {
      setCompareFilter(dashboardFilter[0].filter);
    }
  }, [currentDashboard, dashboardFilter]);
  const saveDashboardNames = async () => {
    setEditDashboard(false);
    try {
      setLoading(true);
      const existingDashboards =
        (originalSetting &&
          originalSetting.dashboardNames &&
          originalSetting.dashboardNames) ||
        [];

      const dashboardKeys = ["dashboard1", "dashboard2", "dashboard3"];

      // Build new dashboard names list based on formData and existing data
      const updatedDashboardNames =
        dashboardKeys &&
        dashboardKeys.map((key, index) => {
          const formValue =
            dashboardFormData &&
            dashboardFormData[key] &&
            dashboardFormData[key]; // Dashboard from formData
          const existingDashboard =
            existingDashboards &&
            existingDashboards[index] &&
            existingDashboards[index]; // Existing dashboard entry

          return {
            key: key,
            name:
              formValue ||
              (existingDashboard &&
                existingDashboard.name &&
                existingDashboard.name) ||
              `Dashboard ${index + 1}`,
          };
        });

      const dashboardNames =
        updatedDashboardNames &&
        updatedDashboardNames.map((dashboard) => dashboard.name);
      const hasDuplicates =
        dashboardNames &&
        new Set(dashboardNames).size !== dashboardNames.length;

      if (hasDuplicates) {
        // alert("Error: Dashboard names must be unique.");
        swal("Error", "Dashboard names must be unique.", "error");
        setDashboardFormData(null);
        return; // Prevent further execution if names are duplicated
      }

      const payload = {
        ...originalSetting,
        dashboardNames: updatedDashboardNames,
      };

      console.log("Final Payload:", payload);
      const response = await DEATH_API.updateUserAssetSetting(payload);
      if (response && response.status === 200) {
        await getUserRole();
      }
    } catch (error) {
      console.error("Error updating user settings:", error);
    } finally {
      setLoading(false);
    }
    setDashboardFormData(null);
  };
  const handleInputChange = (name, value) => {
    setDashboardFormData({
      ...dashboardFormData,
      [name]: value,
    });
  };

  const handleCancelDashbordNames = () => {
    setEditDashboard(false);
    setDashboardFormData(null);
  };

  const updateUserSetting = async () => {
    try {
      setLoading(true);
      const settings =
        localStorage.getItem("setting") != "undefined" &&
        JSON.parse(localStorage.getItem("setting") || null);
      if (settings) {
        setOriginalSetting(settings);
        if (settings.dashboardNames) {
          const updatedFilters =
            settings.dashboardNames &&
            settings.dashboardNames.map((dashboard, index) => ({
              id: index + 1,
              filter: dashboard.name || `Dashboard ${index + 1}`,
              component: `SavedDashboard${index + 1}`,
            }));

          setDashboardFilter(updatedFilters);

          const firstDashboard =
            settings.dashboardNames &&
            settings.dashboardNames.find(
              (dashboard) => dashboard.key === "dashboard1"
            );
          if (firstDashboard) {
            setCompareFilter(firstDashboard.name);
          }
        } else {
          setDashboardFilter([
            { id: 1, filter: "Dashboard 1", component: "SavedDashboard1" },
            { id: 2, filter: "Dashboard 2", component: "SavedDashboard2" },
            { id: 3, filter: "Dashboard 3", component: "SavedDashboard3" },
          ]);
        }
        if (settings.showOnboardingWidget !== undefined) {
          setShowOnboardingWidget(settings.showOnboardingWidget);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const getUserRole = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getUpdatedRole();
      if (data && data.data && data.data.setting) {
        localStorage.setItem("setting", JSON.stringify(data.data.setting));
        setOriginalSetting(data.data.setting);
        const settings = data.data.setting;
        if (settings.dashboardNames) {
          const updatedFilters =
            settings.dashboardNames &&
            settings.dashboardNames.map((dashboard, index) => ({
              id: index + 1,
              filter: dashboard.name || `Dashboard ${index + 1}`,
              component: `SavedDashboard${index + 1}`,
            }));

          setDashboardFilter(updatedFilters);
          const firstDashboard =
            settings.dashboardNames &&
            settings.dashboardNames.find(
              (dashboard) => dashboard.key === "dashboard1"
            );
          if (firstDashboard) {
            setCompareFilter(firstDashboard.name);
          }
        } else {
          setDashboardFilter([
            { id: 1, filter: "Dashboard 1", component: "SavedDashboard1" },
            { id: 2, filter: "Dashboard 2", component: "SavedDashboard2" },
            { id: 3, filter: "Dashboard 3", component: "SavedDashboard3" },
          ]);
        }
        if (settings.showOnboardingWidget !== undefined) {
          setShowOnboardingWidget(settings.showOnboardingWidget);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    updateUserDragCards();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const renderDashboardComponent = (filter) => {
    switch (filter) {
      case "SavedDashboard1":
        return (
          <SavedDashboard1
            dragButtonVisible={dragButtonVisible}
            setDragButtonVisible={setDragButtonVisible}
            setUnsavedDraggableState={setUnsavedDraggableState}
            unsavedDraggableState={unsavedDraggableState}
            setSaveTilesLoading={setSaveTilesLoading}
            saveTilesLoading={saveTilesLoading}
            callState={callState}
            selectedTitles={selectedTitlesForDashboard1}
          />
        );
      case "SavedDashboard2":
        return (
          <SavedDashboard2
            dragButtonVisible={dragButtonVisible}
            setDragButtonVisible={setDragButtonVisible}
            setUnsavedDraggableState={setUnsavedDraggableState}
            unsavedDraggableState={unsavedDraggableState}
            setSaveTilesLoading={setSaveTilesLoading}
            saveTilesLoading={saveTilesLoading}
            callState={callState}
            selectedTitles={selectedTitlesForDashboard2}
          />
        );
      case "SavedDashboard3":
        return (
          <SavedDashboard3
            dragButtonVisible={dragButtonVisible}
            setDragButtonVisible={setDragButtonVisible}
            setUnsavedDraggableState={setUnsavedDraggableState}
            unsavedDraggableState={unsavedDraggableState}
            setSaveTilesLoading={setSaveTilesLoading}
            saveTilesLoading={saveTilesLoading}
            callState={callState}
            selectedTitles={selectedTitlesForDashboard3}
          />
        );
      default:
        return null; // Handle the case where no dashboard matches
    }
  };

  return (
    <div
      className="switch-dashboard-main-container"
      style={{
        backgroundColor: theme === "dark" ? "#161616" : "#F4F7FE",
      }}
    >
      <div
        className="switch-dashboard-main-container-inner"
        style={{
          paddingInline: "1rem",
          width: userRole === "FreeTrail"
            ? "100%"
            : openNotificationContainer
              ? "calc(100% - 230px)"
              : "calc(100% - 60px)",
        }}
      >
        <div
          style={{
            marginTop: "1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexFlow: "wrap",
            position: "relative",
          }}
        >
          <h3
            style={{
              marginTop: "10px",
              color: theme === "light" ? "#2A3DA3" : "#ffffff",
              display: "flex",
              alignItems: "baseline",
              gap: "4px"
            }}
          >
            Financial Dashboard <ToolTipCreator name={"financial_dashboard"} />
          </h3>
          <div
            className="compareSelectContainer "
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "10px",
            }}
          >
            <div className="dashboardFilters">
              {dashboardFilter && dashboardFilter.length === 0 && <DashboardNamesSkeleton />}
              <div className="compareSelect">
                {dashboardFilter && dashboardFilter.length > 0
                  && dashboardFilter.map((item, index) => (
                    <div
                      style={{}}
                      key={index}
                      className={
                        item.filter === compareFilter
                          ? "selectedfilter"
                          : "unSelectedfilter"
                      }
                      onClick={() => {
                        if (dragButtonVisible) {
                          swal({
                            title: "Are you sure?",
                            text: "Changes have not been saved. Are you sure you want to leave?",
                            dangerMode: true,
                            buttons: ["Leave", "Cancel"],
                            icon: "warning",
                            type: "warning",
                            closeOnConfirm: false,
                            closeOnCancel: false,
                          }).then(async function (isConfirm) {
                            if (isConfirm) {
                              return null;
                            } else {
                              setDragButtonVisible(false);
                              setCompareFilter(item.filter);
                            }
                          });
                        } else {
                          setCompareFilter(item.filter);
                        }
                      }}
                      title={item.filter && item.filter}
                    >
                      {item.filter && item.filter.length > 23
                        ? `${item.filter.slice(0, 20)}...`
                        : item.filter}
                    </div>
                  ))}
              </div>
              {localStorage.getItem('role') && JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client" && (<Icon
                type="edit"
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  color: "#2a3da3",
                }}
                onClick={() => {
                  setEditDashboard(true);
                }}
              />)}
            </div>
            <ToolTipCreator name={"dashboard_tabs"} />
          </div>
          <div
            className="compareSelectContainer"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "10px",
            }}
          >
            <div className="compareSelect">
              {themesData.map((item) => (
                <div
                  key={item.id}
                  className={
                    item.filter.toLowerCase() === theme
                      ? "selectedfilter"
                      : "unSelectedfilter"
                  }
                  onClick={toggleTheme}
                >
                  {item.filter}
                </div>
              ))}
            </div>
          </div>
          <ModalVideo module="Dashboard" autoOpen={true} />
          {localStorage.getItem('role') && JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client" && (
            <div className="tooltip-container">
              <button
                style={{ marginTop: "10px" }}
                className="add-widgets-button"
                onClick={showModal}
              >
                <PlusOutlined /> <p>Add Widget</p>
              </button>
              <ToolTipCreator name={"add_widget"} />
            </div>
        )}
          {!showOnboardingWidget && (
            <div className="tooltip-container">
              <button
                style={{ marginTop: "10px", marginLeft: "10px" }}
                className="add-widgets-button"
                onClick={handleOnboardingOpen}
              >
                <Icon type="unordered-list" /> <p>Onboarding</p>
              </button>
              <ToolTipCreator name={"onboarding"} />
            </div>
          )}
          {loading ? (
            <div
              style={{
                marginTop: "12px",
                marginLeft: "8px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "6px 12px",
                borderRadius: "999px",
                border: "1px solid rgba(74, 98, 255, 0.38)",
                background:
                  "linear-gradient(135deg, rgba(42, 61, 163, 0.20), rgba(42, 61, 163, 0.06))",
                color: theme === "light" ? "#2a3da3" : "#d9e1ff",
              }}
            >
              <Spin size="small" />
              Loading dashboard...
            </div>
          ) : null}
        </div>
        {showOnboardingWidget && (
          <div style={{ width: "100%", marginTop: "20px" }}>
            <NewUserOnboardingWidget
              onClose={handleOnboardingClose}
            />
          </div>
        )}
        <div style={{ width: "100%", marginTop: "1rem" }}>
          {showInitialDashboardSkeleton ? (
            <CustomSkeleton />
          ) : (
            renderDashboardComponent(currentDashboard.component)
          )}
        </div>
      </div>
      {userRole !== "FreeTrail" &&
        <React.Fragment>
          {openNotificationContainer ? (
            <div
              style={{
                backgroundColor: theme === "dark" ? "#232323" : "#ffffff",
              }}
              className="notificationMain"
            >
              <DashboardNotificationSection
                theme={theme}
                setOpenNotificationContainer={setOpenNotificationContainer}
              />
            </div>
          ) : (
            <div
              className=""
              style={{
                backgroundColor: theme === "dark" ? "#232323" : "#ffffff",
                padding: "24px 20px 0 20px",
                minHeight: "100vh",
              }}
            >
              <div
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setOpenNotificationContainer(!openNotificationContainer)
                }
              >
                <img
                  style={{ transform: "rotate(180deg)" }}
                  src={notificationCloseIcon}
                  alt="notificationCloseIcon"
                />
              </div>
            </div>
          )}
        </React.Fragment>
      }
      {editDashboard && (
        <Modal visible={editDashboard} footer={null} closable={false} centered>
          <h3 className="modaltitle">Edit Your Dashboard Names</h3>
          <h3 className="modaltitle" style={{ fontSize: "14px" }}>
            Customize your Dashboard Names
          </h3>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">First Dashboard</h3>
            <input
              className="roleInput"
              placeholder="First Dashboard Name"
              name="dashboard1"
              value={dashboardFormData && dashboardFormData.dashboard1}
              id="itemName"
              onChange={(e) => {
                e.preventDefault();
                handleInputChange(e.target.name, e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Second Dashboard</h3>
            <input
              className="roleInput"
              placeholder="Second Dashboard Name"
              name="dashboard2"
              value={dashboardFormData && dashboardFormData.dashboard2}
              id="itemName"
              onChange={(e) => {
                e.preventDefault();
                handleInputChange(e.target.name, e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Third Dashboard</h3>
            <input
              className="roleInput"
              placeholder="Third Dashboard Name"
              name="dashboard3"
              value={dashboardFormData && dashboardFormData.dashboard3}
              id="itemName"
              onChange={(e) => {
                e.preventDefault();
                handleInputChange(e.target.name, e.target.value);
              }}
            />
          </div>

          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancelDashbordNames();
              }}
            >
              Cancel
            </button>
            <button
              className="savebutton"
              onClick={() => {
                saveDashboardNames();
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      <Modal
        width={"860px"}
        className={
          theme === "dark" ? "darkmodethememodal" : "lightmodethememodal"
        }
        title="Manage Dashboards"
        visible={isModalOpen}
        onCancel={handleCancel}
        theme={theme} // Assuming theme is either 'dark' or 'light'
        footer={[
          <Button
            key="saved"
            type="primary"
            style={{
              backgroundColor: "#2a3da3",
              borderColor: "#2a3da3",
              fontSize: "14px",
            }}
            onClick={handleOk}
          >
            Save
          </Button>,
        ]}
      >
        <SelectDashboardComponentsModal
          setOriginalSetting={setOriginalSetting}
          setUnselectTitles1={setUnselectTitles1}
          setUnselectTitles2={setUnselectTitles2}
          setUnselectTitles3={setUnselectTitles3}
          compareFilterDashboard={compareFilter}
          originalSettings={originalSetting}
          setSelectedTitlesForDashboard1={setSelectedTitlesForDashboard1}
          setSelectedTitlesForDashboard2={setSelectedTitlesForDashboard2}
          setSelectedTitlesForDashboard3={setSelectedTitlesForDashboard3}
        />
      </Modal>
    </div>
  );
};
